export const variables = {
  subjectLine: {
    label: "Subject Line",
    value: "subjectLine",
  },
  fromName: {
    label: "From Name",
    value: "fromName",
  },
  content: {
    label: "Content / Design",
    value: "content",
  },
  scheduleTime: {
    label: "Schedule Time",
    value: "scheduleTime",
  },
} as {
  [key: string]: {
    label: string;
    value: string;
  };
};

export const deliveryOptions = {
  Automatic: { label: "Send automatically", value: "Automatic" },
  Manual: { label: "Send manually", value: "Manual" },
} as {
  [key: string]: {
    label: string;
    value: string;
  };
};

export const resultsAfterType = [
  {
    label: "Hours",
    value: "Hours",
  },
  {
    label: "Days",
    value: "Days",
  },
];

export const winningMetric = {
  Opened: {
    label: "Open rate - The version with the highest open rate wins",
    value: "Opened",
    short: "open rate",
  },
  Clicked: {
    label: "Click rate - The version with the highest click rate wins",
    value: "Clicked",
    short: "click rate",
  },
} as {
  [key: string]: {
    label: string;
    value: string;
    short: string;
  };
};
